//src/production/components/ChemicalForm.jsx
import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import axios from "axios";
import env from "react-dotenv";

const ChemicalForm = ({ RM_name, RM_id, onSave, onCancel, openingQuantity, proceedQuantity, cardDetails, departmentDetails, steps }) => {
  // const [openingQuantity, setOpeningQuantity] = useState('');
  // const [proceedQuantity, setProceedQuantity] = useState('');
    const [openingQty, setOpeningQty] = useState(openingQuantity || ''); // Set initial value
    const [proceedQty, setProceedQty] = useState(proceedQuantity || ''); // Set initial value

    useEffect(() => {
      // Prefill the form with the passed values
      setOpeningQty(openingQuantity);
      setProceedQty(proceedQuantity);
    }, [openingQuantity, proceedQuantity]);

  useEffect(() => {
    const fetchOpeningQuantity = async () => {
      if (RM_id) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productionlocinventory/opening-quantity/${RM_id}`);
          setOpeningQty(response.data.quantity); // Assuming the response has a 'quantity' field
        } catch (error) {
          console.error('Error fetching opening quantity:', error);
        }
      }
    };

    fetchOpeningQuantity();
  }, [RM_id]); // Fetch when RM_id changes

  // console.log("RM ID :-", RM_id);

  const handleSave = () => {
    // Convert quantities to numbers for comparison
    const openingQuantityNum = Number(openingQty);
    const proceedQuantityNum = Number(proceedQty);
    
    // Validation 1: Check if proceedQty > openingQty
    if (proceedQuantityNum > openingQuantityNum) {
      alert(`Please edit Processed quantity (Processed quantity should be less than or equal to Opening quantity: ${openingQuantityNum})`);
      return;
    }

    const data = {
      RM_id,
      RM_name,
      openingQuantity: openingQty,
      proceedQuantity: proceedQty,
    };
  
    onSave(data); // Call the onSave function with the prepared data
  };
  
  // New function to handle backend update
  // const updateToBackend = async () => {
  //   try {
  //     await axios.put(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productionlocinventory/update-chemical-quantity/${RM_id}`, {
  //       quantity: proceedQuantity,
  //     });
  //   } catch (error) {
  //     console.error('Error updating opening quantity:', error);
  //   }
  // };

  return (
    <Box sx={{ mt: 6.5, mb: 27, p: 2, border: '1px solid #ccc', borderRadius: 2, width: '300px' }}>
      <Typography variant="body1" fontWeight="bold" sx={{ textAlign: "center", mb: 2 }}>
        Chemical Details for {RM_name}
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          label="Opening Quantity"
          type="number"
          value={openingQty}
          disabled // Disable the field since it's fetched from the API
          onChange={(e) => setOpeningQty(e.target.value)}
          fullWidth
        />
        <TextField
          label="Processed Quantity"
          type="number"
          value={proceedQty}
          onChange={(e) => setProceedQty(e.target.value)}
          fullWidth
        />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button variant="contained" color="success" onClick={handleSave}>
          Save
        </Button>
        <Button variant="outlined" color="error" onClick={onCancel}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default ChemicalForm;